import { ReadMore } from "../ReadMore";

interface PromptWithContextProps {
  question: string;
  context: string;
}

const PromptWithContext: React.FC<PromptWithContextProps> = ({
  question,
  context,
}) => {
  return (
    <div className="prompt-with-context">
      <div>
        <p className="prompt-answer-subtitle">Question</p>
        <p>
          <ReadMore text={question} />
        </p>
      </div>
      <div>
        <p className="prompt-answer-subtitle">Context</p>
        <p>
          <ReadMore text={context} />
        </p>
      </div>
    </div>
  );
};

export { PromptWithContext };
